// Small helpers that turn machine text from the server (camelCase keys, ISO timestamps) into
// words for the audit log, receipts and "What I set aside".
import { formatShortDateTime, type TimeFormatOptions } from "./time";

/** "allPassed" / "sent_label" / "thread.archived" → "all passed" / "sent label" / "thread archived". */
export function humanizeKey(key: string): string {
  return key
    .replace(/[._]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

const ISO_RE = /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})\b/g;

/** Replace ISO-8601 timestamps inside a sentence with a short local date and time. */
export function humanizeTimestamps(text: string, options: TimeFormatOptions = {}): string {
  return text.replace(ISO_RE, (iso) => formatShortDateTime(iso, options));
}
